"use strict";
/* eslint-disable @typescript-eslint/no-explicit-any */
/* eslint-disable max-len */
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
var _a, _b, _c, _d, _e;
Object.defineProperty(exports, "__esModule", { value: true });
const core_1 = require("@angular/core");
const config_service_1 = require("../../../shared/config/config.service");
const opportunity_1 = require("../shared/models/opportunity/opportunity");
const enums_1 = require("../@shared-types/opportunites/enums");
const interface_service_1 = require("../../../shared/interface/interface.service");
const resource_1 = __importDefault(require("../shared/models/resource/resource"));
const tab_service_1 = require("../../../shared/browser-functions/tab.service");
let OpportunityComponent = class OpportunityComponent {
    constructor(opportunityModel, configService, interfaceService, resourceModel, tabService) {
        this.opportunityModel = opportunityModel;
        this.configService = configService;
        this.interfaceService = interfaceService;
        this.resourceModel = resourceModel;
        this.tabService = tabService;
        this.opportunityId = null;
        this.opportunity = null;
        this.data = null;
        this.actionsSidesheet = false;
        this.stateSheet = null;
        this.activities = null;
        this.infoSheet = false;
        this.sendOfferSheet = null;
        this.navigateToVehicle = (vehicleId, params, redirect, dummyVehicle) => {
            const seachParams = Object.assign({ id: vehicleId }, params);
            if (redirect)
                seachParams.redirect = this.interfaceService.getPath();
            if (dummyVehicle) {
                this.interfaceService.navigateToUrl('/vehicles/dummy', seachParams);
            }
            else {
                this.interfaceService.navigateToUrl('/vehicles/stock', seachParams);
            }
        };
        this.updateState = (update) => __awaiter(this, void 0, void 0, function* () {
            if (!this.opportunityId)
                return;
            yield this.opportunityModel.update(this.opportunityId, update);
            this.ngOnInit();
            this.hideStateSheet();
        });
        this.showOffer = (offerId) => __awaiter(this, void 0, void 0, function* () {
            const offer = yield this.resourceModel.getResource(offerId);
            this.tabService.openTabWithHTML(offer, 'Vorschau Angebot', false);
        });
        this.showStateSheet = (state) => { this.stateSheet = state; };
        this.hideStateSheet = () => { this.stateSheet = null; this.ngOnInit(); };
        this.showInfoSheet = () => { this.infoSheet = true; };
        this.hideInfoSheet = () => { this.infoSheet = false; this.ngOnInit(); };
        this.showActionsSidesheet = () => { this.actionsSidesheet = true; };
        this.hideActionsSidesheet = () => { this.actionsSidesheet = false; };
        this.showSendOfferSidesheet = (offer) => { this.sendOfferSheet = offer; };
        this.hideSendOfferSidesheet = () => { this.sendOfferSheet = null; this.ngOnInit(); };
        const { opportunityId } = this.configService.getRouteParams();
        if (opportunityId)
            this.opportunityId = opportunityId;
    }
    /** The server is queried to return all data associated
     * with an Opportunity: infos, offer, reservations etc.
     * Here we will add all data into `activities` to shown them
     * sorted by date in the app.
     */
    ngOnInit() {
        return __awaiter(this, void 0, void 0, function* () {
            if (!this.opportunityId)
                return;
            this.activities = [];
            this.opportunity = yield this.opportunityModel.get(this.opportunityId);
            this.data = yield this.opportunityModel.getData(this.opportunityId);
            // Add offers to activities
            this.data.offers.forEach((o) => {
                var _a, _b;
                const customerInfos = (_a = this.data) === null || _a === void 0 ? void 0 : _a.infos.filter((i) => i.type === enums_1.EOpportunityInfoType.OFFER_RESPONSE && i.data).filter((i) => i.data.offerId === o.id);
                (_b = this.activities) === null || _b === void 0 ? void 0 : _b.push({
                    type: 'OFFER',
                    data: o,
                    creationDate: o.creationDate,
                    infos: customerInfos || [],
                });
            });
            // Add notes to activities
            this.data.infos
                .filter((i) => i.type === enums_1.EOpportunityInfoType.NOTE)
                .forEach((i) => { var _a; return (_a = this.activities) === null || _a === void 0 ? void 0 : _a.push({ type: 'NOTE', data: i, creationDate: i.creationDate }); });
            // Add reservations to activities
            this.data.infos
                .filter((i) => i.type === enums_1.EOpportunityInfoType.RESERVATION)
                .forEach((i) => { var _a; return (_a = this.activities) === null || _a === void 0 ? void 0 : _a.push({ type: 'RESERVATION', data: i, creationDate: i.creationDate }); });
            // Add sales to activities
            this.data.infos
                .filter((i) => i.type === enums_1.EOpportunityInfoType.SALE)
                .forEach((i) => { var _a; return (_a = this.activities) === null || _a === void 0 ? void 0 : _a.push({ type: 'SALE', data: i, creationDate: i.creationDate }); });
            // Add reservations to activities
            this.data.infos
                .filter((i) => i.type === enums_1.EOpportunityInfoType.AVAILABLE)
                .forEach((i) => { var _a; return (_a = this.activities) === null || _a === void 0 ? void 0 : _a.push({ type: 'AVAILABLE', data: i, creationDate: i.creationDate }); });
            // Add files from templates to activities
            this.data.infos
                .filter((i) => i.type === enums_1.EOpportunityInfoType.TEMPLATE)
                .forEach((i) => { var _a; return (_a = this.activities) === null || _a === void 0 ? void 0 : _a.push({ type: 'TEMPLATE', data: i, creationDate: i.creationDate }); });
            this.activities
                .sort((a, b) => new Date(b.creationDate).valueOf() - new Date(a.creationDate).valueOf());
        });
    }
};
OpportunityComponent = __decorate([
    (0, core_1.Component)({
        selector: 'opportunity',
        templateUrl: require('./opportunity.component.html'),
    }),
    __metadata("design:paramtypes", [typeof (_a = typeof opportunity_1.OpportunityModel !== "undefined" && opportunity_1.OpportunityModel) === "function" ? _a : Object, typeof (_b = typeof config_service_1.ConfigService !== "undefined" && config_service_1.ConfigService) === "function" ? _b : Object, typeof (_c = typeof interface_service_1.InterfaceService !== "undefined" && interface_service_1.InterfaceService) === "function" ? _c : Object, typeof (_d = typeof resource_1.default !== "undefined" && resource_1.default) === "function" ? _d : Object, typeof (_e = typeof tab_service_1.TabService !== "undefined" && tab_service_1.TabService) === "function" ? _e : Object])
], OpportunityComponent);
exports.default = OpportunityComponent;
